import React from "react";

export const biennaleTags = (
  <React.Fragment key="biennale-font">
    <link
      rel="preload"
      as="font"
      href="https://s.catch.com.au/static/catch/fonts/biennale_regular.woff2"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      as="font"
      href="https://s.catch.com.au/static/catch/fonts/biennale_semibold.woff2"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      as="font"
      href="https://s.catch.com.au/static/catch/fonts/biennale_black.woff2"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <style
      dangerouslySetInnerHTML={{
        __html: `
          @font-face {
            font-family: "Biennale";
            font-style: normal;
            font-weight: 900;
            font-display: swap;
            src: url("https://s.catch.com.au/static/catch/fonts/biennale_heavy.woff2")
                format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/biennale_heavy.woff")
                format("woff");
            unicode-range: U+000-5FF;
          }

          @font-face {
            font-family: "Biennale";
            font-style: normal;
            font-weight: 800;
            font-display: swap;
            src: url("https://s.catch.com.au/static/catch/fonts/biennale_black.woff2")
                format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/biennale_black.woff")
                format("woff");
            unicode-range: U+000-5FF;
          }

          @font-face {
            font-family: "Biennale";
            font-style: normal;
            font-weight: 700;
            font-display: swap;
            src: url("https://s.catch.com.au/static/catch/fonts/biennale_black.woff2")
                format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/biennale_black.woff")
                format("woff");
            unicode-range: U+000-5FF;
          }
          @font-face {
            font-family: "Biennale";
            font-style: normal;
            font-weight: 600;
            font-display: swap;
            src: url("https://s.catch.com.au/static/catch/fonts/biennale_semibold.woff2")
                format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/biennale_semibold.woff")
                format("woff");
            unicode-range: U+000-5FF;
          }

          @font-face {
            font-family: "Biennale";
            font-style: normal;
            font-weight: 500;
            font-display: swap;
            src: url("https://s.catch.com.au/static/catch/fonts/biennale_semibold.woff2")
                format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/biennale_semibold.woff")
                format("woff");
            unicode-range: U+000-5FF;
          }

          @font-face {
            font-family: "Biennale";
            font-style: normal;
            font-weight: 400;
            font-display: swap;
            src: url("https://s.catch.com.au/static/catch/fonts/biennale_semibold.woff2")
                format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/biennale_semibold.woff")
                format("woff");
            unicode-range: U+000-5FF;
          }

          @font-face {
            font-family: "Biennale";
            font-style: normal;
            font-weight: 100;
            font-display: swap;
            src: url("https://s.catch.com.au/static/catch/fonts/biennale_regular.woff2")
                format("woff2"),
              url("https://s.catch.com.au/static/catch/fonts/biennale_regular.woff")
                format("woff");
            unicode-range: U+000-5FF;
          }
        `,
      }}
    />
  </React.Fragment>
);
